// extracted by mini-css-extract-plugin
export var cls1 = "index-module--cls1--jvvED";
export var cls2 = "index-module--cls2--nQIYn";
export var cls3 = "index-module--cls3--gB+64";
export var filterLandscape = "index-module--filterLandscape--4Nm-x";